/**
 * ページトップへ戻るボタンの機能
 */
class ScrollToTop {
  constructor() {
    this.button = document.getElementById('scroll-to-top');
    if (!this.button) return;

    this.scrollThreshold = 300; // このピクセル数以上スクロールしたらボタンを表示
    this.init();
  }

  init() {
    // スクロールイベントリスナー
    window.addEventListener('scroll', () => this.handleScroll(), { passive: true });
    
    // ボタンクリックイベント
    this.button.addEventListener('click', () => this.scrollToTop());
    
    // 初回表示チェック
    this.handleScroll();
  }

  handleScroll() {
    if (window.pageYOffset > this.scrollThreshold) {
      this.button.classList.add('visible');
    } else {
      this.button.classList.remove('visible');
    }
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
}

// DOMContentLoaded後に初期化
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ScrollToTop();
  });
} else {
  new ScrollToTop();
}

